// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import MenuButton from '../../_common/MenuButton';
import LogIn from '../LogIn';
import Cart from '../../_common/Cart';
import ThemeSelector from '../../_common/ThemeSelector';
import { generateId } from '../../_common/api/utility';

const CartItem = styled(MenuButton)`
    text-decoration: none;
`;

const MenuList = ({ children, ...props }) => {
    const {
        state: {
            site_config,
        },
    } = useGlobalState();

    return (
        <>
            {
                site_config.menuItems.map(e =>
                    <MenuButton
                        key={generateId()}
                        to={e.href}
                        label={e.label}
                        onClick={() => props.updateOpenState ? props.updateOpenState(false) : null}
                    />
                )
            }
            <CartItem
                onClick={() => props.updateOpenState ? props.updateOpenState(false) : null}
                to={'/checkout'}
            >
                <Cart />
            </CartItem>
            <LogIn nowrap />
            {/* <ThemeSelector /> */}
        </>
    );
}

export default MenuList;